module.exports = "/images/features-section-icon.svg?f8abb3a62329aeabd78bd5f4961befa8";